import * as Phaser from "phaser-ce"
import { Scale } from "../utils/Scale"

export class BackgroundSprite extends Phaser.Sprite {
    constructor(game: Phaser.Game, key: string) {
        super(game, 0, 0, key)
        this.width = Scale.width()
        this.height = Scale.height()
    }

}
